"use strict";

import angular from "angular";

const name = "activeLinkSimple";
const factory = [
    "$state",
    "$transitions",
    ($state, $transitions) => {
        return {
            restrict: "A",
            link: (scope, element, attrs, controller) => {
                if (attrs.activeLinkSref) {
                    const sref = JSON.parse(attrs.activeLinkSref);
                    const activeClass = attrs.activeLinkSimple;
                    if (sref === $state.current.name)
                        element.addClass(activeClass);
                    else element.removeClass(activeClass);
                    scope.$watch(
                        () => $state.current.name,
                        (newState) => {
                            if (sref.findIndex((s) => s === newState) > -1)
                                element.addClass(activeClass);
                            else element.removeClass(activeClass);
                        }
                    );
                }
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
